(ns app.front.view.application-wizard.payment
  "Optional wizard step shown after summary when there are unpaid upfront/deposit
   bills. Embeds the fees-and-payments section so applicants can pay before
   submitting."
  (:require [app.domain.fee.model :as fee-model]
            [app.front.view.application-wizard.subs :as subs]
            [app.front.view.application-wizard.summary :as summary-step]
            [app.front.view.fee.list :as fee-list]
            [app.front.view.payment.checkout :as checkout]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::enter-step
  ;; Bills are paid through shared components that initiate payment without a
  ;; return target. Register the wizard payment step as the default return so the
  ;; user lands back here (in-SPA route + off-site provider redirect path).
  (fn [{:keys [db]} _]
    (let [workspace-id (-> db :route/match :parameters :path :workspace-id)
          branding     (-> db :route/match :path-params :branding)
          params       {:workspace-id workspace-id :step "payment"}]
      {:dispatch [::checkout/set-default-return-opts
                  {:return-path  (href/branded-href branding :view/application-wizard-workspace params)
                   :return-route {:route :view/application-wizard-workspace :params params}}]})))

(rf/reg-event-fx ::leave-step
  (fn [_ _]
    {:dispatch [::checkout/clear-default-return-opts]}))

(rf/reg-sub ::step-completed?
  :<- [::subs/application]
  (fn [application _]
    (let [bills (->> application
                     fee-model/phase-bills
                     (filter #(#{:bill.phase/upfront :bill.phase/deposit} (:bill/phase %))))]
      (and (seq bills)
           (every? fee-list/bill-paid-or-cancelled? bills)))))

(defn view [tr]
  (let [application (<sub [::subs/application])
        loading?    (<sub [::ws-subs/loading-config?])]
    [:div
     [:h5.mt-6.mb-5 (tr [:application-wizard/payment])]
     [fee-list/fees-and-payments-section (util/mmap tr loading?) application]
     [summary-step/submit-guard-results tr {:heading? false}]]))
